import React, {useState} from 'react';
import { MultiSelect } from 'react-multi-select-component';
import styled from 'styled-components/macro';

const StyledMultiSelectDropdown = styled(MultiSelect)`
    width: ${props => props.width ? props.width : '100%'};
    --rmsc-h: ${props => props.height ? props.height : '40px'};
    --rmsc-selected: ${props => props.selectedOptionBackground ? props.selectedOptionBackground : 'rgba(3, 94, 91, 0.2)'};
    --rmsc-hover: ${props => props.hoverColor ? props.hoverColor : 'rgba(3, 94, 91, 0.2)'};
    --rmsc-border: ${props => props.borderColor ? props.borderColor : 'rgb(245, 245, 245)'};
    --rmsc-radius: ${props => props.borderRadius ? props.borderRadius : '5px'};
    --rmsc-gray: ${props => props.color ? props.color : 'rgba(164,164,164,1)'};
    color: ${props => props.color ? props.color : 'rgba(255,255,255,1)'};
    padding: ${props => props.padding ? props.padding : 0};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};
    font-size: ${props => props.fontSize ? props.fontSize : '16px'};
    text-indent: ${props => props.textIndent ? props.textIndent : 0};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'inherit'};
`;


const CheckboxWrapper = styled.div`
height: 17px;
display: flex;
align-items: center;
font-family: "Arimo","Open Sans","HelveticaNeue","Helvetica Neue","Arial","sans-serif";
`

const StyledCheckbox = styled.input`
-webkit-appearance: none;
-moz-appearance: none;
appearance: none;
margin-left: -5px;

&:checked:before {
content: '•';
color: ${props => props.bulletColor ? props.bulletColor : 'green'};
font-size: 25px;
padding-right: 2px;
}
&:before {
content: '•';
color: transparent;
font-size: 25px;
padding-right: 2px;
}
`

function MultiSelectDropdown (props) {
    const [selected, setSelected] = useState([]);


      const customItemRenderer = ({option, checked, onClick}) => {
        return (
          <CheckboxWrapper>
            <StyledCheckbox {...props} type='checkbox' checked={checked} onChange={onClick}/>
            {option.label}
          </CheckboxWrapper>
        )
      }

    const customValueRenderer = (selected, _options) => {
        if (selected.length === 1) {
            return <p>{selected[0].label}</p>
        } else if (selected.length > 1 && selected.length < _options.length) {
            return <p>{selected.length} {props.multiSelectionText}</p>
        }
    };

    const handleChange = (e) => {
        setSelected(e);
        if(props.onChange)props.onChange(e);
    }


    return (
            <StyledMultiSelectDropdown
                {...props}
                overrideStrings={{
                    "allItemsAreSelected": `${props.allItemsText ? props.allItemsText : "All"}`,
                    "selectSomeItems": `${props.placeholder ? props.placeholder : "Select"}`,
                    "search": `${props.searchText ? props.searchText : 'Search'}`,
                    "selectAll": `${props.selectAllText ? props.selectAllText : 'Select All'}`,
                    "noOptions": `${props.noOptionsText ? props.noOptionsText : 'No options'}`,
                }}
                valueRenderer={props.valueRenderer ? props.valueRenderer : customValueRenderer}
                ItemRenderer={props.itemRenderer ? props.itemRenderer : customItemRenderer}
                multiSelectionText={props.multiSelectionText ? props.multiSelectionText : 'Selected'}
                options={props.options ? props.options : []}
                value={props.value ? props.value : selected}
                onChange={handleChange}
            />
    )
}

export default MultiSelectDropdown;